"use strict";Object.defineProperty(exports, "__esModule", {value: true});// src/visually-hidden.ts
var _visuallyhidden = require('@ariakit/react-core/visually-hidden/visually-hidden');



exports.VisuallyHidden = _visuallyhidden.VisuallyHidden;
